import { render, staticRenderFns } from "./qlist.vue?vue&type=template&id=4f2cfacf&scoped=true&"
import script from "./qlist.vue?vue&type=script&lang=js&"
export * from "./qlist.vue?vue&type=script&lang=js&"
import style0 from "./qlist.vue?vue&type=style&index=0&id=4f2cfacf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2cfacf",
  null
  
)

export default component.exports